export default __webpack_public_path__ + "static/media/LexendDeca-Light.a4189701.ttf";